.shell {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.content {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.mainArea {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
}

.topBar {
    display: flex;
    justify-content: flex-end;
    padding: 6px 22px 0px;
    background: var(--exo-color-background-secondary);
}

.main {
    flex: 1;
    overflow-y: auto;
    padding: 32px;
    background: var(--exo-color-background-secondary);
}

.themeToggle {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border: none;
    border-radius: 6px;
    background: none;
    font-size: 13px;
    font-weight: 500;
    color: var(--exo-color-font);
    cursor: pointer;
}

.themeToggle:hover {
    background: var(--exo-color-background-secondary);
}
